export const CONSENT_KEY = "cp-cookie-consent";

export function hasConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
}

export function injectScript(
  id: string,
  src: string,
  attrs?: Record<string, string>,
): void {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.src = src;
  script.async = true;
  if (attrs) {
    for (const [key, value] of Object.entries(attrs)) {
      script.setAttribute(key, value);
    }
  }
  document.head.appendChild(script);
}

export function removeScript(id: string): void {
  document.getElementById(id)?.remove();
}

export function initUmami(websiteId: string, scriptUrl: string): void {
  injectScript("umami-script", scriptUrl, {
    "data-website-id": websiteId,
    "data-auto-track": "false",
  });
}

export function initClarity(projectId: string): void {
  if (document.getElementById("clarity-script")) return;
  const script = document.createElement("script");
  script.id = "clarity-script";
  script.textContent = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)})(window,document,"clarity","script","${projectId}");`;
  document.head.appendChild(script);
}

export function trackPageView(url: string): void {
  if (hasConsent() && window.umami) {
    window.umami.track((props) => ({ ...props, url }));
  }
}
